// @flow

import React from "react";
import { localize } from "redux-i18n";
import classNames from "classnames";
import { GSGrid, View, Text } from "@components";
import type {
  DynamicQuestionContent,
  AbsenceReason,
} from "@modules/service/reducer/dynamic-questions/types";
import type { DynamicQuestion } from "@modules/service/reducer/dynamic-questions/types";

type Props = $Exact<{
  data: DynamicQuestionContent,
  ...PropsFromLocalize,
}>;

export class DynamicQuestionReasonSpecificUsageView extends React.Component<Props> {
  get columns() {
    return [
      {
        name: this.props.t("ABSENCE_REASONS"),
        key: "label",
        align: "left",
        renderCell: ({ row }: { row: DynamicQuestionContent }) => {
          return (
            <View direction="row" justifyContent="space-between" flex={1}>
              <View className={!row.isActive ? "text-color-negative" : ""}>{row.label}</View>
              {!row.isActive && (
                <Text color="negative">{this.props.t("INACTIVE_REASON_LABEL")}</Text>
              )}
            </View>
          );
        },
      },
    ];
  }

  get data() {
    return this.props.data.absenceReasons;
  }

  render() {
    return this.data && <GSGrid columns={this.columns} rows={this.data} />;
  }
}

export default localize()(DynamicQuestionReasonSpecificUsageView);
